import React, { Component } from "react";

import { round } from "../../../utils/tools";

import dayjs from "dayjs";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  header: {
    marginBottom: "12pt",
  },
  title: {
    fontSize: "18pt",
    margin: "0 0 10pt",
    textAlign: "center",
  },
  infoTable: {
    borderCollapse: "collapse",
    width: "100%",
  },
  infoCell: {
    padding: "2pt 4pt",
    verticalAlign: "top",
  },
  bordereauTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    width: "100%",
  },
  columnHeader: {
    backgroundColor: "#afaeae",
    border: "1px solid #000000",
    padding: "4pt",
    textAlign: "center",
    verticalAlign: "middle",
  },
  cell: {
    border: "1px solid #000000",
    padding: "3pt",
    verticalAlign: "top",
  },
  amountCell: {
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  totalLabelCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
  },
  totalAmountCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
};

export default class BordereauPDF extends Component {
  render() {
    const { reglements, numRemise, dateRemise, societes, journals } = this.props;

    let nbElements = 0;
    let montant = 0;

    reglements.forEach((reglement) => {
      montant += parseFloat(reglement.reglement_montant);
      nbElements++;
    });

    montant = round(montant, 2);

    const jrnBanque = journals.filter(
      (j) => j.journal_libelle === "BANQUE" || j.journal_libelle === "Banque"
    );

    return (
      <div style={styles.document}>
        {/* ENTETE */}
        <div style={styles.header}>
          <h1 style={styles.title}>BORDEREAU DE REMISE</h1>
          <table style={styles.infoTable}>
            <tbody>
              <tr>
                <td width="50%" style={styles.infoCell}>
                  Date de remise :{" "}
                  {dayjs(dateRemise, "YYYY-MM-DD").isValid()
                    ? dayjs(dateRemise, "YYYY-MM-DD").format("DD/MM/YYYY")
                    : dayjs().format("DD/MM/YYYY")}
                  <br />
                  Type de remise : Chèque
                  <br />
                  Numéro de remise : {numRemise}
                </td>
                <td width="50%" style={styles.infoCell}>
                  Raison sociale : {societes[0].societe_raison_sociale}
                  <br />
                  Compte à créditer :{" "}
                  {jrnBanque[0].journal_compte_bancaire.compte_bancaire_num_compte}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* TOTAL */}
        <table style={styles.bordereauTable}>
          <thead>
            <tr>
              <th width="15%" style={styles.columnHeader}>
                <b>Banque</b>
              </th>
              <th width="15%" style={styles.columnHeader}>
                <b>N° chèque</b>
              </th>
              <th width="50%" style={styles.columnHeader}>
                <b>Libellé</b>
              </th>
              <th width="20%" style={styles.columnHeader}>
                <b>Montant</b>
              </th>
            </tr>
          </thead>
          <tbody>
            {reglements.map((reglement, i) => {
              return (
                <tr key={i}>
                  <td width="15%" style={styles.cell}>
                    {reglement.reglement_banque}
                  </td>
                  <td width="15%" style={styles.cell}>
                    {reglement.reglement_numero_cheque}
                  </td>
                  <td width="50%" style={styles.cell}>
                    {reglement.reglement_tire}
                  </td>
                  <td width="20%" style={styles.amountCell}>
                    {parseInt(reglement.reglement_montant) !== 0 ? (
                      parseFloat(reglement.reglement_montant).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })
                    ) : (
                      <></>
                    )}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td colSpan="2" width="30%" style={styles.totalLabelCell}></td>
              <td width="50%" style={styles.totalLabelCell}>
                {nbElements} chèque(s)
              </td>
              <td width="20%" style={styles.totalAmountCell}>
                <strong>
                  {parseInt(montant) !== 0 ? (
                    parseFloat(montant).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })
                  ) : (
                    <></>
                  )}
                </strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
